import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { HeadModelForDropdownDto } from '../../api/models';

export type TABLE_TYPE = Table<HeadModelForDropdownDto>;

export const TABLE = 'headModelForDropdownDtoFairway';
const SCHEMA = 'headModelId, sortId';

class HeadModelForDropdownDtoFairwayDatabase implements DataRepository<HeadModelForDropdownDto> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  // common methods:
  get(key: Key): Promise<HeadModelForDropdownDto | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: HeadModelForDropdownDto, key: Key): Promise<HeadModelForDropdownDto> {
    return this.db[TABLE].put(payload, key);
  }

  bulkAdd(payload: HeadModelForDropdownDto[]): Promise<HeadModelForDropdownDto[]> {
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<HeadModelForDropdownDto[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const HeadModelForDropdownDtoFairwayDB = new HeadModelForDropdownDtoFairwayDatabase(db);
